export default __webpack_public_path__ + "static/hero-bg-08bfcdc62d4605da423267eb8ae8c416.png";